(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('VoceBilancio', VoceBilancio);

    VoceBilancio.$inject = ['$resource', 'DateUtils'];

    function VoceBilancio ($resource, DateUtils) {
        var resourceUrl =  'api/voce-bilancios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
